var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestionAsked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "r2oa8gskja",
    d: "M1.5 0C.672 0 0 .671 0 1.5v9c0 .828.672 1.5 1.5 1.5H5v2c0 .414.336.743.75.75.263.005.394-.084 1.06-.75l1.926-2H13.5c.828 0 1.5-.672 1.5-1.5v-9c0-.829-.672-1.5-1.5-1.5h-12zm-.2 1.3h12.4v9.488H8.337l-2.336 2.435v-2.435H1.3V1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "mbs7ew92yc",
    d: "M0 3.532h1.333c0-.732.601-1.333 1.334-1.333C3.401 2.199 4 2.8 4 3.532 4 4.866 2 4.7 2 6.866h1.333c0-1.5 2-1.667 2-3.334C5.333 2.059 4.14.866 2.667.866 1.193.866 0 2.059 0 3.532z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-904 -959) translate(904 954) translate(0 5)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "valtmitr4b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r2oa8gskja"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#32315C",
    d: "M-5 19.8L20 19.8 20 -5 -5 -5z",
    mask: "url(#valtmitr4b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#32315C",
    d: "M7 10.2L8.333 10.2 8.333 8.866 7 8.866z",
    transform: "translate(-904 -959) translate(904 954) translate(0 5)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-904 -959) translate(904 954) translate(0 5) translate(5 1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "kzrvwj4esd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#mbs7ew92yc"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#32315C",
    d: "M-5 11.866L10.333 11.866 10.333 -4.134 -5 -4.134z",
    mask: "url(#kzrvwj4esd)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionAsked);
export default __webpack_public_path__ + "static/media/question-asked.cb2b4231ec26644cab12cb5006ba1a9d.svg";
export { ForwardRef as ReactComponent };